<template>
  <el-popover
    v-if="userStore.isAgent"
    v-model:visible="popoverVisible"
    placement="bottom"
    trigger="click"
    popper-class="zone-selector-wrap"
    :width="260"
 >
    <div class="zone-selector">
      <p class="selector-title">{{ title }}</p>
      <div class="selector-content" @click="handleListClick">
        <template v-for="(zone, index) in userStore.zoneList" :key="zone.circleId">
          <div v-if="index % 2 !== 0" class="divider-box">
            <el-divider direction="vertical" class="divider-vertical" />
          </div>
          <div
            class="zone-item"
            :class="{ active: zone.circleId === userStore.zoneId }"
            :data-id="zone.circleId"
         >
            <span class="line1" :data-id="zone.circleId">{{ zone.name }}</span>
          </div>
        </template>
      </div>
    </div>
    <template #reference>
      <slot :zoneName="userStore.zoneName" />
    </template>
  </el-popover>
  <slot v-else :zoneName="userStore.zoneName" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import useUserStore from '@/store/modules/user';
import useCrmebMenuStore from '@/store/modules/menu';
import { findFirstMenuUrl } from '@/utils/crmebMenu';

defineSlots<{
 default(props: { zoneName: string }): unknown;
}>();

const userStore = useUserStore();
const crmebMenu = useCrmebMenuStore();
const router = useRouter();
const popoverVisible = ref(false);

const title = computed(() => {
  const userType = userStore.isMerAdmin ? '商户' : '区域';
  return `${userType}(${userStore.zoneList.length})`;
});

async function handleListClick(e: MouseEvent) {
  const target = e.target as HTMLElement | null;
  const id = target?.dataset?.id;
  if (id === undefined) return;
  userStore.setZoneId(Number(id));
  popoverVisible.value = false;
  await userStore.loadProfile();
  await userStore.getMenus();
  const home = findFirstMenuUrl(crmebMenu.menuTree);
  if (home) {
    await router.replace(home);
  }
}
</script>

<style scoped lang="scss">
.zone-selector {
  max-height: 310px;
  overflow: auto;
}

.selector-title {
  font-weight: 500;
  font-size: 14px;
  color: #666;
  position: sticky;
  top: 0;
  margin-bottom: 10px;
  background-color: #fff;
}

.selector-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 0;
}

.divider-box {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zone-item {
  height: 28px;
  font-size: 12px;
  border-radius: 4px;
  flex: 0 1 calc(50% - 10px);
  display: flex;
  align-items: center;
  padding-inline: 10px;
  cursor: pointer;
  transition: all 0.3s;
  overflow: hidden;

  &.active {
    background-color: rgba(55, 125, 255, 0.1);
  }

  &:hover {
    background-color: #f7f7f7 !important;
  }
}

.divider-vertical {
  background-color: #eee;
}

.line1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style lang="scss">
.zone-selector-wrap {
  padding: 12px !important;
}
</style>
